import React from 'react'
import {Container, Row,Col} from "reactstrap"
import { FaInstagram, FaFacebookSquare,FaYoutube,FaWhatsapp} from 'react-icons/fa';

const Footer = ()=> {
    return (
        <div className="footer py-4 text-white">
            <Container>
                <Row>
                    <Col md="8">
                        <h4>SUPPORT</h4>
                        <p className="mb-4">In case of any issues with registration or website you can contact us at <a className="mail" href="mailto:takshashila@citchennai.net">takshashila@citchennai.net</a><br></br>General Queries  (+91 98941 07330)<br></br>Events  (+91 92454 99401)</p> 
                    </Col>
                    <Col md="4">
                        <h4>CONNECT</h4>
                        <a target="_top" href="https://wa.me/message/6PZWOWB3RMZ7D1" className="mr-2 icon wp"><FaWhatsapp size="1.6rem"></FaWhatsapp></a>
                        <a target="_top" href="https://www.instagram.com/cittakshashila/" className="mx-2 icon insta"><FaInstagram size="1.6rem"></FaInstagram></a>
                        <a target="_top" href="https://www.facebook.com/cittakshashila/" className="mx-2 icon fb"><FaFacebookSquare size="1.5rem"></FaFacebookSquare></a>
                        <a target="_top" href="https://www.youtube.com/channel/UC3dqkYXtt3qA3GHYop75Yeg" className="mx-2 icon yt"><FaYoutube size="1.6rem"></FaYoutube></a>
                    </Col>
                </Row>
                </Container>
        </div>
    )
}

export default Footer;